// You can write more code here

/* START OF COMPILED CODE */

import Phaser from 'phaser';
import BtnPauseMusic from '../core/prefabs/BtnPauseMusic';
import BtnPauseAudio from '../core/prefabs/BtnPauseAudio';
import BtnPauseClose from '../core/prefabs/BtnPauseClose';
import BtnHomeEnd from '../core/prefabs/BtnHomeEnd';
/* START-USER-IMPORTS */
import { app } from '../core/App';
import GameUI from '../scenes/GameUI';
import UIButton from './../core/components/UIButton';
/* END-USER-IMPORTS */

export default class PauseMenu extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // menu
    const menu = scene.add.container(0, 0);
    this.add(menu);

    // menuBg
    const menuBg = scene.add.image(0, 0, 'common', 'popup-pause.png');
    menu.add(menuBg);

    // btnPauseMusic
    const btnPauseMusic = new BtnPauseMusic(scene, 195, 0);
    menu.add(btnPauseMusic);

    // btnPauseAudio
    const btnPauseAudio = new BtnPauseAudio(scene, 0, 0);
    menu.add(btnPauseAudio);

    // btnPauseClose
    const btnPauseClose = new BtnPauseClose(scene, 335, -130);
    menu.add(btnPauseClose);

    // btnHome
    const btnHome = new BtnHomeEnd(scene, -195, 0);
    menu.add(btnHome);

    this.cover = cover;
    this.menu = menu;
    this.menuBg = menuBg;
    this.btnPauseMusic = btnPauseMusic;
    this.btnPauseAudio = btnPauseAudio;
    this.btnPauseClose = btnPauseClose;
    this.btnHome = btnHome;

    /* START-USER-CTR-CODE */
    this.menuBg.setInteractive();
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private menu: Phaser.GameObjects.Container;
  private menuBg: Phaser.GameObjects.Image;
  private btnPauseMusic: BtnPauseMusic;
  private btnPauseAudio: BtnPauseAudio;
  private btnPauseClose: BtnPauseClose;
  private btnHome: BtnHomeEnd;
  public menuStartY: number = -600;
  public menuEndY: number = 0;

  /* START-USER-CODE */

  private closeCallback: (() => void) | undefined;

  public activate(closeCallback?: () => void) {
    this.closeCallback = closeCallback;

    this.transitionIn();
  }

  protected transitionIn() {
    this.btnPauseAudio.setButtonState(!this.getSFXAudioIsMuted());
    this.btnPauseMusic.setButtonState(!this.getMusicAudioIsMuted());

    this.btnPauseClose.once(UIButton.events.clicked, this.transitionOut, this);
    this.btnHome.once(UIButton.events.clicked, this.onHome, this);
    this.btnPauseAudio.on(UIButton.events.clicked, this.toggleSFXAudio, this);
    this.btnPauseMusic.on(UIButton.events.clicked, this.toggleMusicAudio, this);

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250
    });

    this.scene.time.delayedCall(250, () => {
      this.cover.setInteractive();
      this.cover.once(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    });
  }

  protected beforeExit() {
    this.cover.disableInteractive();
    this.cover.off(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);

    this.btnPauseClose.off(UIButton.events.clicked, this.transitionOut, this);
    this.btnHome.off(UIButton.events.clicked, this.transitionOut, this);
    this.btnPauseAudio.off(UIButton.events.clicked, this.toggleSFXAudio, this);
    this.btnPauseMusic.off(UIButton.events.clicked, this.toggleMusicAudio, this);

    this.scene.tweens.killTweensOf([this.menu, this.cover]);
  }

  protected transitionOut() {
    this.beforeExit();

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets: this.cover,
      alpha: 0,
      duration: 250,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.time.delayedCall(650, () => {
      this.closeCallback?.();
    });
  }

  protected onHome() {
    this.beforeExit();
    
    app.audioHandler.setChannelPause('sfx', false);
    app.audioHandler.setChannelPause('music', false);

    this.scene.events.emit(GameUI.events.Home);
  }

  protected getSFXAudioIsMuted(): boolean {
    return app.audioHandler.getChannelMute('sfx');
  }

  protected getMusicAudioIsMuted(): boolean {
    return app.audioHandler.getChannelMute('music');
  }

  protected toggleSFXAudio() {
    let isMuted = this.getSFXAudioIsMuted();
    app.audioHandler.setChannelMute('sfx', !isMuted);
  }

  protected toggleMusicAudio() {
    let isMuted = this.getMusicAudioIsMuted();
    app.audioHandler.setChannelMute('music', !isMuted);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
